import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Pedido } from '../types'

export default function Pedidos() {
  return (
    <PaginaOperaciones<Pedido>
      titulo="Pedidos"
      recurso="pedidos"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'clienteNombre', titulo: 'Cliente' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'prioridad', titulo: 'Prioridad' },
        { campo: 'fechaEntregaEstimada', titulo: 'Entrega estimada', render: (p) => p.fechaEntregaEstimada?.split('T')[0] || '-' },
      ]}
      campos={[
        { nombre: 'clienteId', etiqueta: 'Cliente ID', tipo: 'numero', requerido: true },
        { nombre: 'puntoEntregaId', etiqueta: 'Punto entrega ID', tipo: 'numero' },
        { nombre: 'folio', etiqueta: 'Folio', tipo: 'texto', requerido: true },
        { nombre: 'prioridad', etiqueta: 'Prioridad', tipo: 'select', requerido: true, opciones: [
          { valor: 'Baja', texto: 'Baja' },
          { valor: 'Normal', texto: 'Normal' },
          { valor: 'Alta', texto: 'Alta' },
        ]},
        { nombre: 'fechaEntregaEstimada', etiqueta: 'Entrega estimada', tipo: 'texto' },
        { nombre: 'observaciones', etiqueta: 'Observaciones', tipo: 'textarea' },
      ]}
      valorInicial={{ tenantId: 1, estado: 'Pendiente', prioridad: 'Normal' }}
      puedeCrear={true}
      acciones={[
        {
          label: 'Autorizar',
          endpoint: (p) => `pedidos/${p.id}/estado`,
          body: () => ({ estado: 'Autorizado' }),
          metodo: 'PUT',
        },
      ]}
    />
  )
}
